// src/pages/services/AbhyangaMassage.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import leaf from '../../assets/leaf1.png';
import heroImg from '../../assets/Abhyanga Massage.png';
import doctorImg from '../../assets/doctors4.png';
import Navbar from '../../common/Navbar';
import Footer from '../../common/Footer';

const AbhyangaMassage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-sm md:text-base leading-relaxed">
      <Navbar />

      {/* Hero Section - Perfect Mobile */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#E8E0D5] to-[#F8F3EA]">
        <div className="absolute inset-0 bg-black/45 z-10"></div>
        <img 
          src={heroImg} 
          alt="Abhyanga Massage" 
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        <div className="relative z-20 text-center px-6 max-w-5xl mx-auto flex flex-col justify-center h-full">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-playfair font-bold text-white mb-6 drop-shadow-2xl leading-tight">
            Abhyanga Massage
          </h1>
          <p className="text-base sm:text-lg md:text-2xl lg:text-3xl text-white/95 font-light leading-relaxed max-w-4xl mx-auto drop-shadow-lg px-4">
            The loving touch of warm herbal oils — nourishing body, calming mind, and awakening deep inner peace.
          </p>
        </div>

        <img src={leaf} className="absolute top-20 left-4 sm:left-10 w-24 sm:w-32 opacity-30 animate-float" />
        <img src={leaf} className="absolute bottom-20 sm:bottom-32 right-4 sm:right-16 w-32 sm:w-40 opacity-25 animate-float" style={{ animationDelay: '2s' }} />
        <img src={leaf} className="absolute top-1/2 -left-10 sm:-left-16 w-36 sm:w-44 opacity-20 animate-float" style={{ animationDelay: '4s' }} />
      </section>

      {/* Benefits Section - Perfect Grid on Mobile */}
      <section className="py-16 sm:py-24 px-6 bg-[#F8F3EA]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-playfair text-center text-[#0B2A2C] mb-16">
            The Gift of Loving Touch
          </h2>
          <div className="grid md:grid-cols-3 gap-10">
            {[
              { icon: "", title: "Deep Nourishment", desc: "Herbal oils penetrate tissues, feed every cell" },
              { icon: "", title: "Improves Circulation", desc: "Moves Prana and blood smoothly" },
              { icon: "", title: "Lymphatic Detox", desc: "Flushes toxins, reduces swelling" },
              { icon: "", title: "Calms Nervous System", desc: "Instantly reduces Vata & stress" },
              { icon: "", title: "Stronger Muscles & Joints", desc: "Lubricates and strengthens" },
              { icon: "", title: "Youthful Skin", desc: "Delays aging, gives natural glow" }
            ].map((b, i) => (
              <div 
                key={i} 
                className="bg-white rounded-3xl p-8 sm:p-10 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-4 border border-[#E4D7C2]/50 flex flex-col items-center text-center"
              >
                <div className="text-6xl mb-6">{b.icon}</div>
                <h3 className="text-2xl font-bold text-[#0B2A2C] mb-4">{b.title}</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section - Perfect Mobile Timeline */}
      <section className="py-20 sm:py-28 px-4 sm:px-6 lg:px-8 bg-[#E4D7C2]">
  <div className="max-w-5xl mx-auto flex flex-col gap-10 sm:gap-12">
    <h2 className="text-3xl sm:text-4xl md:text-4xl font-playfair text-[#0B2A2C] mb-8 sm:mb-12 text-center">
      Sacred Flow of Loving Touch
    </h2>

    <div className="flex flex-col gap-8 sm:gap-10 lg:gap-12">
      {[
        { step: "Warm Herbal Oil Selection", desc: "Customized for your dosha and current needs" },
        { step: "Gentle Full-Body Application", desc: "Long, rhythmic strokes in 7 positions" },
        { step: "Marma Point Activation", desc: "Energy points gently stimulated" },
        { step: "Warm Steam (Swedana)", desc: "Opens channels, helps oil penetrate deeper" },
        { step: "Rest & Integration", desc: "Quiet time to absorb the healing energy" },
      ].map((item, i) => (
        <div
          key={i}
          className={`flex flex-col lg:flex-row items-center lg:items-start gap-5 lg:gap-8
            ${i % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}
        >
          {/* Smaller Number Circle */}
          <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 lg:w-16 lg:h-16 
            bg-[#0B2A2C] text-white rounded-full 
            flex items-center justify-center text-lg sm:text-xl lg:text-xl font-bold 
            shadow-lg border-4 border-[#E4D7C2]/40 relative z-10">
            {i + 1}
          </div>

          {/* Much Smaller Card */}
          <div className="w-full max-w-md lg:max-w-lg">
            <div className="bg-white rounded-2xl p-5 sm:p-6 lg:p-7 
              shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 
              border border-[#E4D7C2]/70 
              min-h-[100px] sm:min-h-[110px] lg:min-h-[120px] 
              flex flex-col justify-center items-center lg:items-start text-center lg:text-left">
              <h4 className="text-lg sm:text-xl lg:text-xl font-bold text-[#0B2A2C] mb-2 sm:mb-3">
                {item.step}
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Doctor Quote - Full Width Mobile */}
      <section className="py-20 sm:py-24 px-6 bg-gradient-to-r from-[#0B2A2C] to-[#1A4D4F] text-white text-center">
        <div className="max-w-4xl mx-auto">
          <img 
            src={doctorImg} 
            alt="Dr. V. K. Subrahmanyeswara Rao" 
            className="w-36 h-36 sm:w-40 sm:h-40 rounded-full mx-auto mb-8 sm:mb-10 border-4 sm:border-8 border-amber-300/30 shadow-2xl"
          />
          <blockquote className="text-2xl sm:text-3xl md:text-4xl font-joan italic leading-relaxed max-w-5xl mx-auto px-4">
            “Abhyanga is love made visible — when warm oil touches the skin, it touches the soul.”
          </blockquote>
          <p className="mt-8 sm:mt-10 text-base sm:text-lg md:text-xl opacity-90">
            — Dr. V. K. Subrahmanyeswara Rao
          </p>
        </div>
      </section>

      {/* Final CTA - Perfect Mobile Spacing */}
      <section className="py-20 sm:py-28 px-6 text-center bg-[#F8F3EA]">
        <div className="max-w-4xl text-center flex-col mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-playfair text-[#0B2A2C] text-center mb-12 sm:mb-16">
            Feel the Healing Power of Touch
          </h2>
          <p className="text-base sm:text-lg text-gray-700 max-w-2xl mx-auto mb-10 sm:mb-12 px-4">
            Experience the most nurturing therapy in Ayurveda
          </p>
          <button 
            onClick={() => navigate("/BookNow")}
            className="bg-[#0B2A2C] text-white px-16 py-6 rounded-full text-xl md:text-2xl font-medium hover:bg-[#1A4D4F] transition-all hover:shadow-2xl hover:scale-105"
          >
            Book Your Abhyanga Session
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AbhyangaMassage;